import { MapPin, Phone, Clock, Instagram } from "lucide-react";
import { PHONE_DISPLAY, INSTAGRAM_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#0A0A0A] px-5 sm:px-8 pt-16 pb-28 sm:pb-16" data-testid="footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        <div>
          <img
            src="/logo-on-dark.png"
            alt="AutoHQ — Keep Your Auto Moving"
            className="h-14 w-auto"
            data-testid="footer-logo"
          />
          <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
            Multi-brand car service center — Ranigunj, Secunderabad,
            Hyderabad, Telangana.{" "}
            <a
              data-testid="footer-maps-link"
              href="https://share.google/TX6nbPfh9EcwRHvB5"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#FF5A00] hover:underline"
            >
              Get directions →
            </a>
          </p>
          <div className="mt-4 space-y-2 text-sm text-neutral-400">
            <p className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#FF5A00]" />
              <a data-testid="footer-phone-link" href={`tel:${(PHONE_DISPLAY || "").replace(/\s/g, "")}`} className="hover:text-white">{PHONE_DISPLAY}</a>
            </p>
            <p className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-[#FF5A00]" /> Open 24/7
            </p>
            <p className="flex items-center gap-2">
              <Instagram className="w-4 h-4 text-[#FF5A00]" />
              <a data-testid="footer-instagram-link" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                @autohq.india
              </a>
            </p>
          </div>
        </div>

        <div>
          <p className="text-sm font-bold uppercase tracking-wider text-neutral-500 mb-3 flex items-center gap-2">
            <MapPin className="w-4 h-4 text-[#FF5A00]" /> Find Us
          </p>
          <iframe
            title="AutoHQ Location"
            src="https://www.google.com/maps?q=Auto+HQ,+Ranigunj,+Secunderabad,+Hyderabad&output=embed"
            className="w-full h-44 rounded-lg border border-[#262626] grayscale opacity-80"
            loading="lazy"
          />
        </div>

        <div>
          <p className="text-sm font-bold uppercase tracking-wider text-neutral-500 mb-3">Reward Terms</p>
          <ul className="text-xs text-neutral-500 space-y-2 leading-relaxed" data-testid="footer-terms">
            <li>· One reward per mobile number.</li>
            <li>· Rewards are non-transferable.</li>
            <li>· Coupons valid for 14 days from issue date.</li>
            <li>· AutoHQ reserves the right of final decision on all rewards.</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-[#1F1F1F] text-xs text-neutral-600">
        © {new Date().getFullYear()} AutoHQ, Ranigunj, Hyderabad. All rights reserved.
      </div>
    </footer>
  );
}
